export default "__VITE_ASSET__sWsE2PXk__"